<template>
    <a href="javascript:void(0)" @click="open">
        <i class="fa-solid fa-arrow-right-from-bracket color:#FF6D60"></i>
        <span class="color:#FF6D60">登出</span>
    </a>
    <confirm-modal backdrop="true" :buttons="{ cancel: '取消', confirm: '確認' }" @confirm="logout" ref="logoutModal">
        <div class="font-weight:700">
            請問您是否要登出
            <br>
            OPT歐趴糖？
        </div>
    </confirm-modal>
    <confirm-modal backdrop="true" :buttons="{ cancel: '離開', confirm: '繼續寫' }" @cancel="logout" ref="preventModal">
        提醒您！
        <br>
        離開此頁面已寫內容將不儲存
    </confirm-modal>
</template>

<script setup>
    const props = defineProps({
        path: { type: String }
    });

    const logoutModal = ref();
    const preventModal = ref();

    const unloadPreventer = new UnloadPreventStore();

    const open = () => {
        if (unloadPreventer.isOn()) {
            preventModal.value.show();
            return;
        }
        logoutModal.value.show();
    }

    const logout = () => {
        if (unloadPreventer.isOn()) {
            unloadPreventer.off();
        }

        api("api/member/logout", {}).always(() => {
            if (["evaluation", "exam"].indexOf(props.path) >= 0) {
                window.location.href = "course";
            } else {
                window.location.reload();
            }
        });
    }
</script>
